import React from 'react';
import { FormFieldBase, FormFieldInput } from '.';
import { getFieldProperties, getFieldPropertyValues } from './helpers';

export const FormFieldNumber = ({
  field,
  isRenderedField,
  onChange,
  value,
  onBlur,
  validationMessage,
  readOnly,
}) => {
  const properties = getFieldProperties(field, ['common', 'specific']);
  const { limit, min, max } = getFieldPropertyValues(properties.specific, ['limit', 'min', 'max']);
  const options = {
    properties,
    isRenderedField,
    onChange,
    value,
    onBlur,
    validationMessage,
    readOnly,
  };

  if (limit) {
    // min/max values can be zero which is falsey so check for undefined/null explicitely
    if (min !== undefined && min !== null) options.min = min;
    if (max !== undefined && max !== null) options.max = max;
  }

  return <FormFieldInput field={field} options={options} />;
};

FormFieldNumber.defaultProps = {
  isRenderedField: false,
  onChange: () => { },
  onBlur: () => { },
  readOnly: false,
};

export default FormFieldBase(FormFieldNumber);
